
const scheduleScrollTypes = {
	TODAY: "TODAY",
	SELECTED_DATE: "SELECTED_DATE",
	WEEK_CHANGE: "WEEK_CHANGE",
	SELECTED_MEETING: "SELECTED_MEETING",
};

export default Object.freeze( scheduleScrollTypes );





// WEBPACK FOOTER //
// ./src/constants/ScheduleScrollType.js